    var swiper = new Swiper(".banner-grid-slider", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
       scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true,
      },
       breakpoints: {
          990: {
            slidesPerView: 1.2,
            spaceBetween: 10,
          },
         
          0: {
            slidesPerView: 1.2,
            spaceBetween: 10,
          }
        }
    });


 function goToURL(url) {
    window.location.href = url;
  }


    // var swiper = new Swiper(".collection-grid-slider", {
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev",
    //   },
    //    scrollbar: {
    //     el: ".swiper-scrollbar",
    //     hide: false,
    //     draggable: true,
    //   },
    //    breakpoints: {
    //       990: {
    //         slidesPerView: 1,
    //         spaceBetween: 10,
    //       },
       
    //       0: {
    //         slidesPerView: 1,
    //         spaceBetween: 10,
    //       }
    //     }
    // });

